import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.186 4.691a1.085 1.085 0 0 1 0 1.527l-8.57 8.628a1.07 1.07 0 0 1-1.517 0l-4.285-4.314a1.085 1.085 0 0 1 0-1.527 1.07 1.07 0 0 1 1.516 0l3.53 3.549 7.813-7.863a1.07 1.07 0 0 1 1.516 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }